import HttpFactory from '@/mixins/http.factory';
import download from "downloadjs";
import customAgGrid from '@/components/custom-ag-grid/custom-ag-grid.vue';
import dateTimeRenderer from '@/components/custom-ag-grid/dateTimeRenderer/dateTimeRenderer.vue';
import booleanRenderer from '@/components/custom-ag-grid/booleanRenderer/booleanRenderer.vue';
export default {
	mixins:[HttpFactory],
	data () {
		return {
            params:{userId:null,requestType:null},
            filters:{searchText:null},
            data: [],
            dataFetchSet:[],
            columnDefs:[],
            gridOptionsApi: null,
            userPaymentInfo:null
		};
	},
	created(){
        const _self=this;
        _self.initCols();
		_self.init();
	},
	methods:{
        async init(){
            
            this.params={
                userId:this.$route.params.userId,
                requestType:this.$route.params.requestType
            };
            await this.fetchUserPaymentInfo();
            this.fetchData();
        },
        async fetchData(){
            const _self=this;
            _self.fn().clearMessage();
            try{
                let data={
                    searchText:_self.filters.searchTextAPI
                };
                let response=await _self.post(`tickets/${this.params.userId}/${this.params.requestType}`,data);
                if(response && response.data){
                    _self.data = response.data.Data;
                    _self.dataFetchSet = JSON.parse(JSON.stringify(_self.data));
                }else{
                    _self.userMsg.list=['An error occurred!! Please try again later'];
                }
            }catch(ex){
				_self.commonErrorMsgDisp(ex);
			}finally{
				_self.userMsg.show=true;
				_self.fn().showLoader(false);
			}
        },
        async updateTicketLoggedInUser(paramsData){
			const _self=this;
			_self.fn().clearMessage();
            //let data = JSON.parse(JSON.stringify(paramsData));
            let data = {
                oldLoggedInUserInfo: paramsData.oldValue,
                loggedInUserInfo: paramsData.newValue,
                userId: paramsData.userId,
                requestType: paramsData.requestType,
            };

            if (_self.params.requestType == 'monday-devops')
                data.linkedTicketIds= _self.dataFetchSet.filter(d => d.loggedInUserInfo == paramsData.oldValue).map(d => d.hdItemId)
            else
                data.linkedTicketIds= _self.dataFetchSet.filter(d => d.loggedInUserInfo == paramsData.oldValue).map(d => d.hdTicketId)
            
            var url = `tickets/updateTicketLoggedInUser/${_self.params.userId}/${_self.params.requestType}`
            try {
                let response = await _self.put(url, data);
                _self.fn().showLoader(false);
                if (response && response.data) {
                    _self.userMsg.type = 'info';
                    _self.userMsg.list = ['Data updated successfully'];
                    _self.fetchData();
                } else {
                    _self.userMsg.list = ['An error occurred!! Please try again later'];
                }
            } catch (ex) {
                console.log(ex);
                _self.commonErrorMsgDisp(ex);
            } finally {
                _self.userMsg.show = true;
                _self.fn().showLoader(false);
            }
		},
        async fetchUserPaymentInfo(){
            const _self=this;
            _self.fn().clearMessage();
            try{
                let response = await _self.get(`payments/user/${this.params.userId}/${this.params.requestType}`);
                
                if(response && response.data){
                    _self.userPaymentInfo = response.data.Data[0];
                }else{
                    _self.userMsg.list=['An error occurred!! Please try again later'];
                }
            }catch(ex){
				_self.commonErrorMsgDisp(ex);
			}finally{
				_self.userMsg.show=true;
				_self.fn().showLoader(false);
			}
        },
        async filterAPIData(){
            const _self=this;
            _self.fetchData();
        },
        onGridOptionsApi(params){
            this.gridOptionsApi=params;
        },
        async filterData(){
            const _self=this;
            const searchText=_self.filters.searchText;
            _self.gridOptionsApi.api.setQuickFilter(searchText);
        },
        extraCallBackFn(params){
            const _self=this;
            let data=params.data;
            data.isPaid=data.isPaid==1?0:1;
            if(data.isPaid==0){
                data.isPremium=0;
                data.isUsersAccess=0;
            }else{
                data.isActive=1;
                data.isDeleted=0;
            }
            _self.updateCustomer(data);
        },
        extraCallBackFn1(params){
            const _self=this;
            let data=params.data;
            
        },
        copyData(){
            let _self = this;
            if (!_self.userPaymentInfo) {
                alert("No User Payments Info found!!!");
                return;
            }
            let data = _self.data;
            let currentPlanData = data.filter(d => new Date(d.createdOn) >= new Date(_self.userPaymentInfo.startDate) && new Date(d.createdOn) <= new Date(_self.userPaymentInfo.endDate));
            let loggedInUserInfos = currentPlanData.map(d => d.loggedInUserInfo).filter((value, index, self) => self.indexOf(value) === index);
            
            let strResponse = '';
            for (var i = 0; i < loggedInUserInfos.length; i++){
                strResponse += `${i+1}. ${loggedInUserInfos[i]}\n`;
            }
            _self.doCopyVal(strResponse,'Logged In Agents License data copied');
        },
        async doCopyVal(message,successMsg){
            const _self=this;
            let isCopied=await _self.$copyText(message)
            if(isCopied){
                _self.userMsg={show:true,type:'primary',list:['You just copied: ' + successMsg?successMsg:message]};
            }
        },
        exportData(){
			let _self=this;
			let data=_self.data;
			_self.fn().sortNumCol(data,'hdTicketId',true);
			let defaultNullVal='-';
			let fileName = `linked_tickets.csv`;
			let csvData = `Ticket #, Subject, Workitem #, Type, Project, Title, Status, Assignee, Logged In User Info, Description, CreatedOn \r\n`;
			data.forEach(function (item) {
				let row = `${_self.fn().formatCSV(item.hdTicketId?item.hdTicketId:defaultNullVal)},${_self.fn().formatCSV(item.hdSubject?item.hdSubject:defaultNullVal)},${_self.fn().formatCSV(item.workItemId?item.workItemId:defaultNullVal)},${_self.fn().formatCSV(item.workItemType?item.workItemType:defaultNullVal)},${_self.fn().formatCSV(item.projectName?item.projectName:defaultNullVal)},${_self.fn().formatCSV(item.devOpsTitle?item.devOpsTitle:defaultNullVal)},${_self.fn().formatCSV(item.status?item.status:defaultNullVal)},${_self.fn().formatCSV(item.assignedTo?item.assignedTo:defaultNullVal)},${_self.fn().formatCSV(item.loggedInUserInfo?item.loggedInUserInfo:defaultNullVal)},${_self.fn().formatCSV(item.description?item.description:defaultNullVal)},${_self.fn().formatCSV(item.createdOn?_self.filter().formatDateTime(item.createdOn):defaultNullVal)}`;
				csvData += row + "\r\n";
			});
			download(csvData, fileName, 'data:application/csv;charset=utf-8');
		},
        initCols(){
            const _self  =this;
            let commonWidth=125;//=120;
            _self.columnDefs = [
                { headerName: 'App Name', field: 'requestType',width: commonWidth },
                { headerName: 'User Email', field: 'userEmail',width: commonWidth,valueFormatter(params){
                    return params.value?params.value:params.data.hdEmail;
                } },
                { headerName: 'HD Login Url', field: 'hdLoginUrl',width: commonWidth },
                // { headerName: 'HD Email', field: 'hdEmail',width: commonWidth },
                //{ headerName: 'DevOps Url', field: 'devOpsUrl',width: commonWidth },
                { headerName: 'Created On', field: 'createdOn',width: commonWidth,cellRendererFramework:dateTimeRenderer },
                { headerName: 'Ticket #', field: 'hdLoginUrl', width: commonWidth,cellClass:'text-left',
                    cellRenderer: function (params) {
                        let hdTicketUrl='';
                        switch(params.data.requestType){
                            case 'zendesk-devops':
                                hdTicketUrl=`${params.data.hdLoginUrl}/agent/tickets/${params.data.hdTicketId}`;
                                break;
                            case 'freshdesk-devops':
                                hdTicketUrl=`${params.data.hdLoginUrl}/a/tickets/${params.data.hdTicketId}`;
                                break;
                            case 'freshservice-devops':
                                hdTicketUrl=`${_self.fn().getFSTicketUrl(params.data.hdLoginUrl,params.data.hdTicketId,params.data.type)}`;
                                break;
                            default:
                                break;
                        }
                      return `<a href="${hdTicketUrl}" target="_blank">${params.data.hdTicketId}</a>`;
                  }
                },
                { headerName: 'Subject', field: 'hdSubject',width: commonWidth },
                { headerName: 'Workitem #', field: 'devOpsUrl', width:100,
                  cellRenderer:function(params){
                      return `<a href="${params.value}/${params.data.projectId}/_workitems/edit/${params.data.workItemId}" target="_blank">${params.data.workItemId}</a>`;
                  }	
                },
                { headerName: 'Type', field: 'workItemType',width: commonWidth },
                { headerName: 'Project', field: 'projectId',width: commonWidth },
                { headerName: 'Title', field: 'devOpsTitle',width: commonWidth },
                { headerName: 'HD Status', field: 'hdStatus',width: commonWidth },
                { headerName: 'Status', field: 'status',width: commonWidth },
                { headerName: 'Assignee', field: 'assignedTo',width: commonWidth },
                {
                    headerName: 'Logged In User Info', editable: true, field: 'loggedInUserInfo', width: commonWidth,
                    onCellValueChanged: (params) => {
                        if (params.oldValue != params.newValue) {
                            _self.updateTicketLoggedInUser(params);
                        }
                    },
                 },
                { headerName: 'Type', field: 'type',width: commonWidth },
                //{ headerName: 'Description', field: 'description',width: commonWidth },
              ];

        },
    },
    components:{customAgGrid}
}

